"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumberInput = _interopRequireDefault(require("./NumberInput"));

var DateInput = function DateInput(_ref) {
  var format = _ref.format,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["format"]);
  return /*#__PURE__*/_react.default.createElement(_NumberInput.default, (0, _extends2.default)({}, otherProps, {
    format: format
  }));
};

DateInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Value that controls the  */
  value: _propTypes.default.string,

  /** Hash based string */
  format: _propTypes.default.string,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isHiddenLabel: _propTypes.default.bool,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
DateInput.defaultProps = {
  value: '',
  format: '##/##/####',
  errorText: '',
  isHiddenLabel: false,
  fsMask: true
};
var _default = DateInput;
exports.default = _default;